import React, { useState, useEffect } from "react";
import { MODULE_API } from "../../../apis";
import moment from "moment";
export const GoalMonthlySavings = () => {
  const [totalSavings, setTotalSaving] = useState(null);
  const [loading, setLoading] = useState(false);

  const getIncomeTotalMonthly = async () => {
    try {
      setLoading(true);
      const date = moment();
      const startDate = date.startOf("month").format("YYYY-MM-DD"); // Start of the month
      const endDate = date.endOf("month").format("YYYY-MM-DD");
      let datares = await MODULE_API.fetchUserTotalIncomeExpense(
        startDate,
        endDate
      );
      if (datares && datares) {
        const monthlyIncome = datares.total_income || 0;
        const monthlyExpense = datares.total_expenses || 0;
        const totalSaving = monthlyIncome - Math.abs(monthlyExpense);
        console.log("totalllll", totalSaving);
        setTotalSaving(totalSaving);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const getAll = async () => {
    setLoading(true);
    await getIncomeTotalMonthly();
    setLoading(false);
  };
  useEffect(() => {
    getAll();
  }, []);

  return (
    <div>
      <div
        className="descriptionDisplay"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap:"8px"
        }}
      >
        Your Monthly Saving Capacity:{" "}
        {loading ? (
          <span>
            <div
              className="skeleton"
              style={{ width: "70px", height: "30px",marginBottom:"0px" }}
            ></div>
          </span>
        ) : (
          <span>
            {" "}
            {totalSavings && totalSavings !== undefined && totalSavings !== null
              ? "$" +
                totalSavings.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              : "$0"}
          </span>
        )}
      </div>
    </div>
  );
};
